import React, { Component, Fragment } from 'react';

import { Button } from 'react-bootstrap';

import { BrowserRouter } from 'react-router-dom';

import AppRoute from './route/AppRoute';
import AppRouter from './router/AppRouter';
// import ChatBot from './components/ChatBot/ChatBot';
import  { lazy, Suspense } from 'react';
const ChatBot = lazy(() => import('./components/ChatBot/ChatBot'));

class App extends Component {
  // state = {
  //   count: 0,
  // };

  // increase = () => {
  //   this.setState({ count: this.state.count + 2 });
  // };

  render() {
    return (
      <Fragment>
        <BrowserRouter>
          <AppRouter />
          <Suspense fallback={null}>
            <ChatBot />
          </Suspense>
        </BrowserRouter>

      </Fragment>
    );
  }
}

export default App;



